import CloneVoiceWizardModal from '@/components/Modals/CloneVoiceWizardModal/CloneVoiceWizardModal';
import { useGetVoicesSeats } from '@/components/Modals/CloneVoiceWizardModal/useGetVoicesSeats';
import SingUpModal from '@/components/Modals/SingUpModal';
import UpgradePlanModal from '@/components/Modals/UpgradePlanModal';
import { toast } from '@/components/toast';
import SoundWave from '@/images/Soundwave.png';
import { useAuth } from '@/services/auth';
import { cloneVoiceUpgradePlanModal, cloneVoiceWizardModal, ttsSignupModal } from '@/state/presenters';
import { PlanGroup } from '@d-id/types';
import { useEffect } from 'react';
import { useRecoilState } from 'recoil';

interface Props {
    setMode: (mode: 'select' | 'clone-voice') => void;
    onClose: () => void;
    onClone: () => void;
}
const UNSUPPORTED_PLAN_CLONE_VOICE = [PlanGroup.LITE, PlanGroup.TRIAL, PlanGroup.FREE];

export const CloneVoiceContent = ({ setMode, onClose, onClone }: Props) => {
    const [wizardModal, setCloneVoiceWizardModal] = useRecoilState(cloneVoiceWizardModal);
    const { user, isAnonymous } = useAuth();
    const [signupModalState, setSignupModalState] = useRecoilState(ttsSignupModal);
    const [showCloneVoiceUpgradeModal, setShowCloneVoiceUpgradeModal] = useRecoilState(cloneVoiceUpgradePlanModal);
    const { data: seats, isFetched } = useGetVoicesSeats();

    const handleBack = () => {
        setMode('select');
    };

    const onCloneCompleted = () => {
        onClone();
        setCloneVoiceWizardModal(false);
    };

    const onCloseClick = () => {
        setMode('select');
        onClose?.();
        setCloneVoiceWizardModal(false);
    };
    useEffect(() => {
        if (!isFetched) {
            return;
        }
        if (isAnonymous) {
            setSignupModalState(true);
        } else if (!user || !user.planGroup || UNSUPPORTED_PLAN_CLONE_VOICE.includes(user.planGroup)) {
            setShowCloneVoiceUpgradeModal(true);
        } else if (seats === 0) {
            setMode('select');
            setCloneVoiceWizardModal(false);
            toast.info({
                title: 'Voice cloning limit reached',
                message: 'Delete an existing voice or upgrade your plan to clone additional voices',
            });
        } else {
            setCloneVoiceWizardModal(true);
        }
    }, [seats, isFetched]);

    return (
        <>
            <UpgradePlanModal
                open={showCloneVoiceUpgradeModal}
                onClose={() => {
                    onCloseClick();
                    setShowCloneVoiceUpgradeModal(false);
                }}
                title={<div>Upgrade to Pro to clone more voices</div>}
                imageFile={SoundWave}
                from="clone-voice"
            />
            <SingUpModal
                text="Sign up to clone your voice"
                from="advanced-editor-clone"
                isOpen={signupModalState}
                onClose={() => {
                    onCloseClick();
                    setSignupModalState(false);
                }}
            />
            {wizardModal && (
                <CloneVoiceWizardModal onBack={handleBack} open={wizardModal} onClose={onCloseClick} onClone={onCloneCompleted} />
            )}{' '}
        </>
    );
};
